import { createContext, useContext } from "react";

export interface QuickSearchState {
  readonly open: boolean;
  readonly setOpen: (open: boolean) => void;
}

/** Whether the quick search (Ctrl+K) is open; shared by the header button and the keyboard shortcut. */
export const QuickSearchContext = createContext<QuickSearchState | null>(null);

export function useQuickSearch(): QuickSearchState {
  const state = useContext(QuickSearchContext);
  if (state === null) throw new Error("useQuickSearch must be used inside the app layout");
  return state;
}
